import Blamable               from '@/models/traits/Blamable';
import FondationsServiceModel from '@/models/FondationsServiceModel';
import TimestampAble          from '@widesk-core/models/traits/TimestampAble';
import Translatable           from '@widesk-core/models/traits/Translatable';
import { computed }           from 'mobx';
import doc                    from '@widesk-core/decorators/doc';
import model                  from '@widesk-core/decorators/model';
import config                 from '@/config.ts';
import { SupportedLanguage }  from '@/hooks/useTranslations';

type ShortShowReference = 'sud' | 'paris';

@model.urnResource('entertainment')
@doc.path('/entertainments/{?id}')
export default class FondationsEntertainmentModel extends Blamable(TimestampAble(Translatable(FondationsServiceModel, {
	'title': true,
}))) {
	private declare _tsFilters: {
		'enabled': boolean;
		'dateEnd[after]': string;
		'dateEnd[before]': string;
		'dateEnd[strictly_after]': string;
		'dateEnd[strictly_before]': string;
	};

	private declare _tsSorts: {
		'dateStart': string;
		'dateEnd': string;
		'edition': string;
	};

	@doc.date declare dateStart: Dayjs;
	@doc.date declare dateEnd: Dayjs;

	get logoUrl() {
		return this.get<string, string>('entertainmentMediaLogo.objectUrl', '');
	}

	@computed get showReference() {
		return this.get<string>('show.reference');
	}

	@computed get shortShowReference(): ShortShowReference | undefined {
		return this.showReference?.split('_').at(-1) as ShortShowReference;
	}

	@computed get websiteUrl() {
		return this.shortShowReference ? config.website_url[this.shortShowReference] : '';
	}

	public getTitle(language: SupportedLanguage) {
		return this.get(`translations.${language}.title`, '');
	}
}
